import * as React from "react";

const DialogOverlayContext = React.createContext<HTMLElement | null>(null);

type DialogOverlayProviderProps = {
  element: HTMLElement | null;
  children: React.ReactNode;
};

export function DialogOverlayProvider({ element, children }: DialogOverlayProviderProps) {
  return (
    <DialogOverlayContext.Provider value={element}>
      {children}
    </DialogOverlayContext.Provider>
  );
}

export function useDialogOverlayElement() {
  return React.useContext(DialogOverlayContext);
}
